/* UNIT — en-tête : menu mobile, méga-menu au toucher, ancres fluides */
(function () {
  if (window.__uHeader) return;
  window.__uHeader = true;
  var doc = document, html = doc.documentElement;

  function drawer() {
    var d = doc.getElementById('UMobileMenu');
    if (d && d.parentNode !== doc.body) doc.body.appendChild(d);
    return d;
  }
  function openMenu() {
    var d = drawer(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); html.classList.add('u-md-lock');
    var b = doc.querySelector('[data-u-md-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    var c = d.querySelector('.u-md-close'); if (c) setTimeout(function () { c.focus(); }, 300);
  }
  function closeMenu() {
    var d = doc.getElementById('UMobileMenu'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); html.classList.remove('u-md-lock');
    var b = doc.querySelector('[data-u-md-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); }
  }
  function closePanels(except) {
    var items = doc.querySelectorAll('.u-hd-item.is-open');
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== except) {
        items[i].classList.remove('is-open');
        var a = items[i].querySelector('.u-hd-link'); if (a) a.setAttribute('aria-expanded', 'false');
      }
    }
  }
  function goToAnchor(href) {
    var m = /^\/?(?:\?[^#]*)?#([\w-]+)$/.exec(href || '');
    if (!m || location.pathname !== '/') return false;
    var el = doc.getElementById(m[1]);
    if (!el) return false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    try { history.pushState(null, '', '#' + m[1]); } catch (e) {}
    return true;
  }

  drawer();
  doc.addEventListener('DOMContentLoaded', drawer);

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-u-md-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-u-md-close]')) { e.preventDefault(); closeMenu(); return; }

    var acc = t.closest('.u-md-acc');
    if (acc) {
      var li = acc.parentNode;
      var open = li.classList.toggle('is-open');
      acc.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var a = t.closest('a[href]');
    if (a && a.closest('#UMobileMenu')) {
      var h = a.getAttribute('href');
      closeMenu();
      if (goToAnchor(h)) e.preventDefault();
      return;
    }
    if (a && a.closest('.u-hd')) {
      var link = a.closest('.u-hd-link');
      var item = link && link.parentNode;
      // au toucher : 1er appui ouvre le panneau, 2e appui suit le lien
      if (link && item && item.classList.contains('has-panel') && window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
        e.preventDefault(); closePanels(item); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); return;
      }
      var hh = a.getAttribute('href');
      if (goToAnchor(hh)) { e.preventDefault(); closePanels(); }
      return;
    }
    if (!t.closest('.u-hd-item')) closePanels();
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closePanels(); }
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeMenu(); });
})();